import type { FaturaStatusSyncRequest } from '../../../types';

// Cada linha em fatura_status_sync_requests é UMA fatura; um pedido em lote
// (várias faturas do mesmo cliente, mesmo motivo) nasce como um INSERT de
// várias linhas que compartilham exatamente o mesmo `solicitado_em`
// (Postgres avalia NOW() uma vez por statement, não por linha) — por isso
// (solicitado_por_id + solicitado_em) é uma chave de agrupamento confiável,
// sem precisar de uma tabela de "lote" separada.

export interface GrupoSincronizacaoStatus {
    chave: string;
    itens: FaturaStatusSyncRequest[];
    solicitanteNome: string;
    motivo: string;
    solicitadoEm: string;
    vickFazSentido: boolean | null;
    vickComentario: string | null;
    decisao: 'pendente' | 'aprovado' | 'rejeitado';
    decididoPorNome: string | null;
    decididoEm: string | null;
    motivoRejeicao: string | null;
}

export function agruparSincronizacaoStatus(linhas: FaturaStatusSyncRequest[]): GrupoSincronizacaoStatus[] {
    const mapa = new Map<string, FaturaStatusSyncRequest[]>();
    for (const l of linhas) {
        const chave = `${l.solicitado_por_id}__${l.solicitado_em}`;
        if (!mapa.has(chave)) mapa.set(chave, []);
        mapa.get(chave)!.push(l);
    }
    return Array.from(mapa.entries())
        .map(([chave, itens]) => {
            const primeiro = itens[0];
            return {
                chave,
                itens,
                solicitanteNome: primeiro.solicitado_por_nome,
                motivo: primeiro.motivo,
                solicitadoEm: primeiro.solicitado_em,
                vickFazSentido: primeiro.vick_faz_sentido,
                vickComentario: primeiro.vick_comentario,
                decisao: primeiro.decisao,
                decididoPorNome: primeiro.decidido_por_nome,
                decididoEm: primeiro.decidido_em,
                motivoRejeicao: primeiro.motivo_rejeicao,
            };
        })
        .sort((a, b) => new Date(b.solicitadoEm).getTime() - new Date(a.solicitadoEm).getTime());
}
